<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/skODrn/tc-custom/9780226769509.jpg?1730605845109" alt="This image is the cover for the book Complete Works"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Complete Works
      </h1>
      <p class="bookDescription body article font2">
        <b>The complete surviving works of Epictetus, the most influential Stoic philosopher from antiquity.</b><br/><br/> “Some things are up to us and some are not.”<br/>  <br/> Epictetus was born into slavery around the year 50 CE, and, upon being granted his freedom, he set himself up as a philosophy teacher. After being expelled from Rome, he spent the rest of his life living and teaching in Greece. He is now considered the most important exponent of Stoicism, and his surviving work comprises a series of impassioned discourses, delivered live and recorded by his student Arrian, and the <i>Handbook</i>, Arrian’s own take on the heart of Epictetus’s teaching.<br/>  <br/> In <i>Discourses</i>, Epictetus argues that happiness depends on knowing what is in our power to affect and what is not. Our internal states and our responses to events are up to us, but the events themselves are assigned to us by the benevolent deity, and we should treat them—along with our bodies, possessions, and families—as matters of indifference, simply making the best use of them we can. Together, the <i>Discourses</i> and <i>Handbook</i> constitute a practical guide to moral self-improvement, as Epictetus explains the work and exercises aspirants need to do to enrich and deepen their lives. Edited and translated by renowned scholar Robin Waterfield, this book collects the complete works of Epictetus, bringing to modern readers his insights on how to cope with death, exile, the people around us, the whims of the emperor, fear, illness, and much more.<br/><br/><b>CUSTOMER NOTE: THE HARDCOVER IS FOR LIBRARIES AND HAS NO JACKET.</b><br/><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Epictetus, Robin Waterfield
      </h2>
      
      <p class="authorDescription body article"><B>Epictetus</B> (c. 50–135CE) was a Greek stoic philosopher.&#160;<B>Robin Waterfield</B> is an independent scholar and translator living in southern Greece. In addition to thirty volumes of translations of works of Greek literature, he is the author of numerous books, ranging from children’s fiction to Greek history, most recently <I>The Making of a King</I>, also published by the University of Chicago Press.<br> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c282016